import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify' // path to vuetify export

import api from './api/api'
Vue.prototype.$api = api

import utils from './plugins/utils'
Vue.prototype.$utils = utils

/**
 * localStorage 和 sessionStorage 属性允许在浏览器中存储 key/value 对的数据。
 * sessionStorage 用于临时保存同一窗口(或标签页)的数据，在关闭窗口或标签页之后将会删除这些数据。
 * 提示: 如果你想在浏览器窗口关闭后还保留数据，可以使用 localStorage 属性,
 * 改数据对象没有过期时间，今天、下周、明年都能用，除非你手动去删除。 
 * 
 * 下面两行用于在浏览器刷新后在session中取出token和userInfo给Vuex，防止登录信息丢失
 * */
store.commit("settoken", JSON.parse(sessionStorage.getItem("token")));
store.commit("setuserInfo", JSON.parse(sessionStorage.getItem("userInfo")));

api.getConfig({
  key: 'PAGE-LIMIT'
}).then(res => {
  store.state.glimit = parseInt(res.data)
}).catch((error) => {
  console.error('getConfig(PAGE-LIMIT):', error)
})

api.getConfig({
  key: 'KAIFA-LTD'
}).then(res => {
  if (res.data != '0') {
    store.state.gzhichi = res.data
  }
}).catch((error) => {
  console.error('getConfig(KAIFA-LTD):', error)
})

router.beforeEach((to, from, next) => {
  //路由发生改变时,触发 - 按照路由配置文件里的meta.title属性修改页面标题
  window.document.title = to.meta.title ? to.meta.title : '承诺达标合格证管理平台'
  next();
})
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')